var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "filter-panel" },
    _vm._l(_vm.filters, function (filter, key) {
      return _c(_vm.filterType(filter), {
        key: key,
        tag: "component",
        attrs: { products: _vm.products, filter: filter },
        model: {
          value: _vm.filterValues,
          callback: function ($$v) {
            _vm.filterValues = $$v
          },
          expression: "filterValues",
        },
      })
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }